// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-70378ef6] .rec-select-menu{min-width:20rem;min-height:3.125rem}[data-v-70378ef6] .rec-select-menu__content-top{display:flex;gap:0.625rem;padding:0.9375rem;background-color:var(--p-d-10)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
